import { OktaAuthOptions } from '@okta/okta-auth-js';
import {
  OKTA_CLIENT_ID,
  APP_ENV,
  OKTA_ISSUER,
  OKTA_AUTHORIZE_URIS,
  OKTA_OIDC_SCOPE,
  IAM_HA_TOKEN_URLS,
  OKTA_REDIRECT_URI,
  OKTA_REDIRECT_URI_FOR_MFE
} from './constants';

export const oktaVars = (isMFE: boolean): OktaAuthOptions => {
  const authVars = {
    issuer: OKTA_ISSUER[APP_ENV] ?? '',
    clientId: OKTA_CLIENT_ID[APP_ENV] ?? '',
    redirectUri: isMFE ? OKTA_REDIRECT_URI_FOR_MFE : OKTA_REDIRECT_URI,
    authorizeUrl: OKTA_AUTHORIZE_URIS[APP_ENV] ?? '',
    scopes: OKTA_OIDC_SCOPE,
    tokenUrl: IAM_HA_TOKEN_URLS[APP_ENV] ?? ''
  };
  return authVars;
};
